import styled from "styled-components";
import Icon from "../../../../../../base/icons/icon/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../styles/common/mixins/logical.styled.js";
import pricesMobileThemes from "./themes/index.js";
export const PricesWrapperMobile = styled.div.withConfig({
    displayName: "styled__PricesWrapperMobile",
    componentId: "sc-8f482bce-0"
})`
	color: ${({ theme  })=>theme.colors.secondary.base};
	margin-left: auto;
	max-width: 45%;
	text-align: end;
	flex-shrink: 0;
	align-self: flex-end;
	align-items: flex-end;
	${FlexMixin({
    direction: 'column',
    align: 'flex-end'
})}
`;
export const PriceTopMobile = styled.div.withConfig({
    displayName: "styled__PriceTopMobile",
    componentId: "sc-8f482bce-1"
})`
	color: ${({ theme  })=>theme.colors.secondary.base};
	${FlexMixin({
    direction: 'column',
    justify: 'flex-end',
    align: 'flex-end'
})}

	.from {
		${FontMixin({
    size: 'smaller',
    height: 'small',
    weight: 'regular'
})}
	}

	.old-price {
		${FontMixin({
    size: 'medium',
    height: 'small',
    weight: 'regular'
})};
		text-decoration: line-through;
	}

	${({ theme  })=>pricesMobileThemes[theme.id]?.PriceTopMobile?.()}
`;
export const PriceCurrentMobile = styled.span.withConfig({
    displayName: "styled__PriceCurrentMobile",
    componentId: "sc-8f482bce-2"
})`
	color: ${({ theme  })=>theme.colors.secondary.base};
	${FontMixin({
    size: 'larger',
    height: 'large',
    weight: 'medium'
})}

	${({ theme  })=>pricesMobileThemes[theme.id]?.PriceCurrentMobile?.()}
`;
export const PricePaxValueMobile = styled.span.withConfig({
    displayName: "styled__PricePaxValueMobile",
    componentId: "sc-8f482bce-3"
})`
	color: ${({ theme  })=>theme.colors.grays.base};

	.per-person {
		${FontMixin({
    size: 'small',
    height: 'small',
    weight: 'regular'
})}
	}

	.pax-value {
		${FontMixin({
    size: 'base',
    height: 'small',
    weight: 'regular'
})}
	}
`;
export const PriceCaptionMobile = styled.div.withConfig({
    displayName: "styled__PriceCaptionMobile",
    componentId: "sc-8f482bce-4"
})`
	color: ${({ theme  })=>theme.colors.grays.base};
	${FontMixin({
    size: 'smaller',
    weight: 'regular',
    height: 'small'
})}
`;
export const PriceTopDealMobile = styled.div.withConfig({
    displayName: "styled__PriceTopDealMobile",
    componentId: "sc-8f482bce-5"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'medium'
})}
	margin-bottom: 4px;

	.discount {
		background-color: ${({ theme  })=>theme.colors.grays.base};
		color: ${({ theme  })=>theme.colors.white.base};
		${BorderRadius({
    all: '4px'
})}
		padding: 1px 4px;
		margin-right: 4px;

		&::after {
			content: '%';
		}
		&::before {
			content: '-';
		}
	}
	.old-price {
		text-decoration: line-through;
	}
`;
export const PriceCurrentDealMobile = styled.div.withConfig({
    displayName: "styled__PriceCurrentDealMobile",
    componentId: "sc-8f482bce-6"
})`
	color: ${({ theme  })=>theme.colors.white.base};
	${FlexMixin({
    align: 'center'
})}
	position: relative;
	${FontMixin({
    size: 'larger',
    weight: 'medium',
    height: 'large'
})}
	background-color: ${({ theme  })=>theme.colors.status.offer};
	padding-right: 12px;
	max-height: 36px;
	min-height: 36px;
	margin-right: -12px;

	&::before {
		content: '';
		height: 0;
		position: absolute;
		top: 0;
		width: 0;
		border-bottom: 18px solid transparent;
		border-right: 12px solid ${({ theme  })=>theme.colors.status.offer};
		border-top: 18px solid transparent;
		left: -12px;
	}

	&.is-blackfriday {
		background-color: ${({ theme  })=>theme.colors.black.base};
	}

	&.is-blackfriday::before {
		border-right-color: ${({ theme  })=>theme.colors.black.base};
	}
`;
export const OnlyIcon = styled(Icon).withConfig({
    displayName: "styled__OnlyIcon",
    componentId: "sc-8f482bce-7"
})`
	color: ${({ theme  })=>theme.colors.secondary.base};
	${FontMixin({
    size: 'large',
    weight: 'bold',
    height: 'large'
})}
`;
export const NoPrice = styled.div.withConfig({
    displayName: "styled__NoPrice",
    componentId: "sc-8f482bce-8"
})`
	${FlexMixin({
    justify: 'flex-end',
    align: 'center'
})}
	margin-left: auto;

	& > span {
		color: ${({ theme  })=>theme.colors.secondary.base};
		${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})};
		margin-right: 8px;
		margin-bottom: 0;
		text-align: right;
	}

	& strong {
		display: block;
		color: ${({ theme  })=>theme.colors.grays.base};
		${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})};
	}

	${Icon} {
		${FlexMixin({
    justify: 'center',
    align: 'center'
})}
		background-color: ${({ theme  })=>theme.colors.secondary.base};
		color: ${({ theme  })=>theme.colors.white.base};
		${BorderRadius({
    all: '50%'
})}
		width: 40px;
		min-width: 40px;
		height: 40px;
	}
`;

//# sourceMappingURL=styled.js.map